var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiContext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-context_svg__clip0_1306_11657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2a6 6 0 110 12 6 6 0 010-12z",
    stroke: "#ACB5C2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 26,
    fill: "#ACB5C2",
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 26,
    fill: "#ACB5C2",
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16l14 5.5V38L6 34V16z",
    stroke: "url(#ai-context_svg__paint0_linear_1306_11657)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16l-14 5.5V38l14-4V16z",
    stroke: "url(#ai-context_svg__paint1_linear_1306_11657)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-context_svg__paint0_linear_1306_11657",
    x1: 6,
    y1: 38,
    x2: 26.035,
    y2: 26.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-context_svg__paint1_linear_1306_11657",
    x1: 34,
    y1: 38,
    x2: 13.965,
    y2: 26.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-context_svg__clip0_1306_11657"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-context-b50a87270631cd041dd7a84ab739b8e5.svg";
export { SvgAiContext as ReactComponent };